<template>
  <div class="personal-panel">
    <div class="personal-desc" :style="{'background':this.$store.state.app.themeColor}">
      <div class="avatar-container">
        <img class="avatar" :src="require('@/assets/head.png')"/>
        <!--<el-upload-->
          <!--class="avatar-uploader"-->
          <!--:action="url"-->
          <!--:show-file-list="false"-->
          <!--:headers="headers"-->
          <!--:on-success="handleAvatarSuccess"-->
          <!--:before-upload="beforeAvatarUpload">-->
          <!--<img v-if="imageUrl" :src="user.portrait" class="avatar">-->
          <!--<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
        <!--</el-upload>-->
      </div>
      <div class="name-role">
        <span class="sender">{{ user.loginName }} - {{ user.displayName }}</span>
      </div>
      <div class="registe-info">
          <span class="registe-info">
            <li class="fa fa-clock-o"></li>
            {{ user.registerDate }}
          </span>
      </div>
    </div>
    <!--<div class="personal-relation">-->
    <!--<span class="relation-item">followers</span>  -->
    <!--<span class="relation-item">watches</span>  -->
    <!--<span class="relation-item">friends</span>-->
    <!--</div>-->
    <div class="main-operation">
        <span class="main-operation-item">
          <el-button size="small" icon="fa fa-male"> 个人中心</el-button>
        </span>
      <span class="main-operation-item">
          <el-button size="small" icon="fa fa-key" @click="changePass"> 修改密码</el-button>
        </span>
    </div>
    <div class="other-operation">
      <div class="other-operation-item" @click="clearCache">
        <li class="fa el-icon-s-cooperation"></li>
        所属部门
        <span class="personal-panel-num" v-if="user.deptName !== ''">{{user.unitName}}
          <li class="fa el-icon-caret-right"></li>{{user.deptName}}
        </span>
        <span class="personal-panel-num" v-if="user.deptName === ''">{{user.unitName}}</span>
      </div>
      <div class="other-operation-item">
        <li class="fa fa-user"></li>
        在线人数 <span class="personal-panel-num">{{user.onlineUsers}}</span>
      </div>
      <div class="other-operation-item">
        <li class="fa el-icon-s-flag"></li>
        登录次数 <span class="personal-panel-num">{{user.loginTimes}}</span>
      </div>
      <div class="other-operation-item">
        <li class="fa el-icon-s-open"></li>
        访问次数 <span class="personal-panel-num">{{user.visitTimes}}</span>
      </div>
      <div class="other-operation-item">
        <li class="fa fa-download"></li>
        <!--        APP下载 <span class="personal-panel-num" @click="appDownloadVisible = true">点击扫码</span>-->
        APP下载 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="/static/html/JustOpma.html" target="_blank">点击扫码</a>
      </div>
      <div class="other-operation-item" @click="clearCache">
        <li class="fa fa-eraser"></li>
        清除缓存
      </div>
    </div>
    <div class="personal-footer" @click="logout">
      <li class="fa fa-sign-out"></li>
      {{$t("common.logout")}}
    </div>
    <ChangePsw ref="ChangePswDialog"></ChangePsw>

  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Cookies from "js-cookie";
  import ChangePsw from "@/views/Sys/ChangePsw"

  let myApp;
  export default {
    name: 'PersonalPanel',
    components: {
      ChangePsw
    },
    props: {
      user: {
        type: Object
      },
      url: {
        default: globalConfig.baseUrl + "/password/imgUpload"
      }
    },
    data() {
      return {
        size: 'small',
        imageUrl: true,
        headers: {
          token: Cookies.get('token')
        }
      }
    },
    methods: {
      //清楚缓存
      clearCache: function () {
        this.$confirm("确定要清除缓存吗?", "提示", {
          type: "warning"
        })
          .then(() => {
            Cookies.set('token', null);
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("menuCode");
            this.$message.info('清除缓存成功!');

            let self = this;
            setTimeout(function () {
              self.$api.login.logout().then((res) => {
                if (res.code == 200) {
                  self.$router.push("/login");
                }
              }).catch(function (res) {
              })
            }, 2000)
          })
          .catch(() => {
          })
      },
      // 退出登录
      logout: function () {
        this.$confirm("确认退出吗?", "提示", {
          type: "warning"
        })
          .then(() => {
            // console.log("---------removeItem")
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("menuCode");
            myApp.$api.login.logout().then((res) => {
              if (res.code === 200) {
                myApp.$router.push("/login");
              }
            }).catch(function (res) {
            })
          })
          .catch(() => {
          })
      },
      // 修改密码界面
      changePass: function () {
        this.$refs.ChangePswDialog.setChangePswVisible(true)
      },

      handleAvatarSuccess(res, file) {
        this.user.portrait = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },

    },
    mounted() {
      myApp = this;
    }
  }
</script>

<style scoped>
  .personal-panel {
    font-size: 14px;
    width: 280px;
    text-align: center;
    border-color: rgba(180, 190, 190, 0.2);
    border-width: 1px;
    border-style: solid;
    background: rgba(182, 172, 172, 0.1);
    margin: -14px;
  }

  .personal-desc {
    padding: 15px;
    color: #fff;
  }

  .avatar {
    width: 60px;
    height: 60px;
    border-radius: 90px;
  }

  .name-role {
    font-size: 16px;
    padding: 5px;
  }

  .personal-relation {
    font-size: 16px;
    padding: 12px;
    margin-right: 1px;
    background: rgba(200, 209, 204, 0.3);
  }

  .relation-item {
    padding: 12px;
  }

  .relation-item:hover {
    cursor: pointer;
    color: rgb(19, 138, 156);
  }

  .main-operation {
    padding: 8px;
    margin-right: 1px;
    /* background: rgba(175, 182, 179, 0.3); */
    border-color: rgba(201, 206, 206, 0.2);
    border-top-width: 1px;
    border-top-style: solid;
  }

  .main-operation-item {
    margin: 15px;
  }

  .other-operation {
    padding: 15px;
    margin-right: 1px;
    text-align: left;
    border-color: rgba(180, 190, 190, 0.2);
    border-top-width: 1px;
    border-top-style: solid;
  }

  .other-operation-item {
    padding: 8px;
  }

  .other-operation-item li{
    width: 15px;
    height: 14px;
  }

  .other-operation-item:hover {
    cursor: pointer;
    background: #9e94941e;
    color: rgb(19, 138, 156);
  }

  .personal-footer {
    margin-right: 1px;
    font-size: 14px;
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
    border-color: rgba(180, 190, 190, 0.2);
    border-top-width: 1px;
    border-top-style: solid;
  }

  .personal-footer:hover {
    cursor: pointer;
    color: rgb(19, 138, 156);
    background: #b1a6a61e;
  }

  .personal-panel-num {
    margin-left: 20px;
    color: orange;
  }
</style>



// WEBPACK FOOTER //
// src/views/Core/PersonalPanel.vue